import api from "./client";

export const acceptReport = (reportId) => {
  return api.post(`/api/report/${reportId}/accept/`);
};

export const returnReport = (reportId, reason) => {
  return api.post(`/api/report/${reportId}/return/`, {
    reason,
  });
};

export const allowEditReport = (reportId) => {
  return api.post(`/api/report/${reportId}/allow-edit/`);
};
